import store from '@/services/store.js';
import { EventBus } from '@/services/Event.js';
import EditProfile from '@/components/user/dashboard/pages/profile/edit-profile/edit-profile.vue';

export default {
    name: 'juniorEditProfile',
    components: {
        EditProfile
    },
    data() {
        return {
            isProcessing: true,
            juniors: [],
            juniorName: '',
            juniorId: -3 //no action required
        }
    },
    computed: {
        loadedUserName() {
            var self = this;
            if (self.juniorName) {
                var id = self.getJuniorIdByName();
                if (id !== self.juniorId) {
                    self.changeJunior(id);
                    self.$console("Loaded edit profile data for junior - " + id + " - " + self.juniorId);
                }
                return self.juniorName;
            }
            return '';
        },
    },
    methods: {
        getJuniorIdByName() {
            var self = this;
            if (self.juniorName == 'new') { //this is not working
                var jun = self.juniors[self.juniors.length - 1];
                store.commit('setCurrentJunior', jun.fullName);
                self.juniorName = jun.fullName;
            }
            var juniorArray = self.juniors.filter(junior => {
                return junior.fullName === self.juniorName;
            });
            if (juniorArray.length) {
                return juniorArray[0].id;
            }
            else {
                return self.juniors[0].id;
            }
        },
        changeJunior(id) {
            this.juniorId = id;
            store.commit('setCurrentJunior', this.juniorName);
            EventBus.$emit("user-load-edit-profile", this.juniorId);
        },
        getData() {
            var self = this;
            var preloadedUser = store.getters.getUserShortInfo;
            if (preloadedUser && preloadedUser.isSuccess) {
                if (preloadedUser.details.juniors && preloadedUser.details.juniors.length > 0) {
                    self.juniors = preloadedUser.details.juniors;
                    self.juniorId = self.getJuniorIdByName();


                    self.$console();
                    self.$console("Loaded juniors:");
                    self.$console({ juniors: self.juniors });
                    self.$console();
                    self.$console("Loaded data for junior - " + self.juniorId + " - " + self.juniorName);
                    
                }
                else {
                    self.$router.push(-1);
                }
                self.isProcessing = false;
            }
        },
    },
    mounted() {
        var self = this;
        EventBus.$off("user-load-junior-edit-profile");
        EventBus.$on("user-load-junior-edit-profile", () => {
            self.getData();
        });
        var currentJun = store.getters.getCurrentJunior;

        if (currentJun) {
            self.juniorName = currentJun;
        }
        self.getData();
    }
}



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/junior/junior-edit-profile/junior-edit-profile.js